import React from 'react'

import { SxProps } from '@mui/material'

import Chip from 'components_new/atoms/Chip'
import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import InputAdornment from 'components_new/atoms/InputAdornment'

import TextField from 'components_new/atoms/TextField'
import { useSnackbarActions } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

interface EndpointProps {
  disabled?: boolean
  href: string
  size?: 'small' | 'medium'
  sx?: SxProps
  variant?: 'delete' | 'get' | 'patch' | 'post'
  overrideVariant?: string
}

const Endpoint = React.forwardRef((props: EndpointProps, ref: any) => {
  const {
    disabled = false,
    href,
    size,
    sx,
    variant = 'get',
    overrideVariant
  } = props

  const getColor = () => {
    switch (variant) {
    case 'delete':
      return 'error'
    case 'get':
      return 'info'
    case 'patch':
      return 'secondary'
    case 'post':
      return 'success'
    default:
      return undefined
    }
  }

  const { toggleSnackbarOpen } = useSnackbarActions()

  const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(href)

    toggleSnackbarOpen(SnackbarMessage.CopiedToClipboard)
  }

  return (
    <TextField
      disabled={disabled}
      InputProps={{
        endAdornment: disabled ? null : (
          <InputAdornment position="end">
            <IconButton onClick={copyLinkToClipboard} size="small">
              <Icon fontSize="small" name="Copy" />
            </IconButton>
          </InputAdornment>
        ),
        startAdornment: (
          <InputAdornment position="start">
            <Chip
              color={getColor()}
              label={overrideVariant || variant}
              size="small"
              sx={{ textTransform: 'uppercase' }}
            />
          </InputAdornment>
        ),
        readonly: true,
        sx: {
          fontWeight: 'bold'
        }
      }}
      ref={ref}
      value={href}
      size={size}
      sx={{
        ...sx
      }}
    />
  )
})

Endpoint.displayName = 'Endpoint'

export default Endpoint
